import axios from 'axios';
import {BASE_URL} from '../environment/stores';

const provider = axios.create({
  baseURL: BASE_URL,
});

export default provider;